import ScalebarControl from './scalebar-control';
import app from '../../public-api';

app.plugins.register({
  name: 'us:scalebar',

  extends: 'viewport',

  dependencies: ['us:user-config'],

  factory (uScope, viewport, userConfig) {
    const scalebar = new ScalebarControl(uScope, viewport, userConfig);

    // Polluting the viewport is a temp hack till I find a better way of handling however this is used.
    viewport.scaleBar = scalebar;

    return scalebar;
  }
});



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/scalebar/scalebar-loader.js